import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import _ from 'lodash';

import { MenuElement } from '../../menu-element';

@Component({
    selector: 'adm4-menu-action',
    template: `
    <ng-template #actionContent>
      <div class='menu-action-inner' matRipple matRippleColor="rgba(255 255 255 / .2)" (mouseenter)="setHover(true)" (mouseleave)="setHover(false)">
        @if (menuElement.useSvg) {
          @if (!isHovered) {
            <mat-icon [svgIcon]='menuElement.icon' [ngbTooltip]="menuElement.title" class="svg-icon"></mat-icon>
          }
          @if (isHovered) {
            <mat-icon  [svgIcon]='invertedIcon' [ngbTooltip]="menuElement.title" class="svg-icon"></mat-icon>
          }
        } @else {
          <mat-icon class="font-icon" [ngbTooltip]="menuElement.title">{{menuElement.icon}}</mat-icon>
        }
        <span class="label text-ellipsis">{{menuElement.title}}</span>
      </div>
    </ng-template>
    
    @if (hasTitle) {
      @if ((!menuElement.href || !(menuElement.href | async))) {
        @if (shouldBeDisplayed) {
          <button role="link" class='menu-action focus-bg-light-grey'
            [class.selected]='isSelected'
            (click)='triggerEvent()'>
            <ng-container *ngTemplateOutlet="actionContent"></ng-container>
          </button>
        }
      } @else {
        @if (shouldBeDisplayed) {
          <a
            [href]='menuElement.href | async' class='menu-action focus-bg-light-grey' [class.selected]='isSelected'>
            <ng-container *ngTemplateOutlet="actionContent"></ng-container>
          </a>
        }
      }
    } @else {
      @if (!menuElement.title && shouldBeDisplayed) {
        <mat-divider></mat-divider>
      }
    }
    `,
    styleUrls: [
        './menu-action.component.scss'
    ],
    standalone: false
})
export class MenuActionComponent implements OnChanges {
  @Input() menuElement: MenuElement;

  public invertedIcon: string | undefined;

  public hasTitle: boolean = false;
  public isHovered: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.menuElement) {
      this.hasTitle = !!this.menuElement?.title;
      this.invertedIcon = this.menuElement.invertedIcon?? this.menuElement.icon;
    }
  }

  get shouldBeDisplayed(): boolean {
    return !_.isFunction(this.menuElement.displayCondition) || this.menuElement.displayCondition();
  }

  get isSelected(): boolean {
    return _.isFunction(this.menuElement.selectedCondition) && this.menuElement.selectedCondition();
  }

  get isDisabled(): boolean {
    return _.isFunction(this.menuElement.disabledCondition) && this.menuElement.disabledCondition();
  }

  triggerEvent(): void {
    if (!_.isFunction(this.menuElement.event)) {
      return;
    }
    const disabled = _.isFunction(this.menuElement.disabledCondition) && this.menuElement.disabledCondition() ;
    if (disabled) {
      return;
    }
    this.menuElement.event();
  }

  public setHover(isHovered: boolean): void {
    this.isHovered = isHovered;
  }
}
